import { queryKeys } from '@/lib/query-keys';
import { orgMembersClient } from '@/lib/api/ts-rest';
import { createLogger } from '@/lib/logger';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const log = createLogger('useInvitationActions');

export function useDeleteInvitation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ invitationId }: { invitationId: string }) => {
      const res = await orgMembersClient.deleteInvitation({
        params: { invitationId },
      });
      if (res.status !== 200) throw new Error('Failed to delete invitation');
      return true;
    },
    onSuccess: () => {
      toast.success('Invitation supprimée avec succès');
      queryClient.invalidateQueries({
        queryKey: queryKeys.organizations.pendingInvitations(),
      });
    },
    onError: (error) => {
      log.error('Error deleting invitation', error);
      toast.error('Oups, une erreur est survenue');
    },
  });
}
